/**
 * Sleeve Stars — Materials & Anatomy interactivity.
 * 5·C: Auto-cycle hotspots every 3s if no user interaction in 6s.
 */
(function () {
  function bind(root) {
    if (root.dataset.ssMatBound) return;
    root.dataset.ssMatBound = '1';

    const dots  = Array.from(root.querySelectorAll('.ss-mat__dot'));
    const items = Array.from(root.querySelectorAll('.ss-mat__item'));
    if (!dots.length) return;

    let auto = null;
    let autoIdx = 0;
    let userInteracted = 0;

    function setActive(id) {
      dots.forEach(d => d.classList.toggle('is-active', d.dataset.matTarget === id));
      items.forEach(i => i.classList.toggle('is-active', i.dataset.matId === id));
    }
    function note() { userInteracted = Date.now(); }

    dots.forEach(dot => {
      const id = dot.dataset.matTarget;
      dot.addEventListener('mouseenter', () => { note(); setActive(id); });
      dot.addEventListener('focus',      () => { note(); setActive(id); });
      dot.addEventListener('click', () => {
        note();
        setActive(id);
        const t = root.querySelector('[data-mat-id="' + id + '"]');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    items.forEach(item => {
      const id = item.dataset.matId;
      item.addEventListener('mouseenter', () => { note(); setActive(id); });
      item.addEventListener('click', () => { note(); setActive(id); });
    });

    // Auto-cycle when idle for >6s
    auto = setInterval(() => {
      if (Date.now() - userInteracted < 6000) return;
      autoIdx = (autoIdx + 1) % dots.length;
      const id = dots[autoIdx].dataset.matTarget;
      setActive(id);
    }, 3000);
  }

  function init() { document.querySelectorAll('.ss-mat').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
